// Port of api/fuel/app/classes/filter/package/games/rating/data/revisions.php
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	run: function(filter, data, config, global) {
		if (!global.gameIds || !global.gameIds.length) return
		var rows = DB.query('SELECT game_id, user_id, log_rating, log_previous, log_date, log_context, log_initial_sync, log_id FROM log_user_rating WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + Util.in(global.userIndex) + ') ORDER BY log_date ASC')
		global.revisions = {}
		for (var i = 0; i < rows.length; i++) {
			var r = rows[i]
			if (!global.revisions[r.game_id]) global.revisions[r.game_id] = []
			global.revisions[r.game_id].push(r)
		}

		if (global.ownerType === 1) {
			var missingGameIds = global.gameIds.filter(function(gameId) { return !global.revisions[gameId] })
			if (missingGameIds.length) {
				var ratingRows = DB.query(
					'SELECT rating_id, game_id, user_id, rating_value FROM rating WHERE user_id IN(' + Util.in(global.userIndex) + ') AND game_id IN(' + Util.in(missingGameIds) + ')'
				)
				var syncDate = global.owner && global.owner.get_date_sync_first ? parseInt(global.owner.get_date_sync_first() || 0, 10) : 0
				for (var j = 0; j < ratingRows.length; j++) {
					var rating = ratingRows[j]
					global.revisions[rating.game_id] = [{
						log_id: 0,
						log_date: syncDate,
						user_id: rating.user_id,
						game_id: rating.game_id,
						log_context: 1,
						log_rating: rating.rating_value,
						log_previous: 0,
						log_initial_sync: 1
					}]
				}
			}
		}
	}
}
